import { ContentFlexComponent, ContentProps } from "components/flexComponents/Content/typings";
import * as React from "react";
import { EditorialInfoView } from "components/flexComponents/Content/factory/impl/items/EditorialInfoView";
import EditorialBase from "components/flexComponents/Content/factory/EditorialBase";

export class InfoViewEditorial extends EditorialBase {
  /* istanbul ignore next */
  constructor(editorial: ContentFlexComponent) {
    super(editorial);
  }

  public generate(props: ContentProps) {
    const classNameAttr = `${this.getEditorialItemClassName()}`;

    if (this.editorial.items.length !== 2) {
      return null;
    }

    return (
      <div
        className={classNameAttr}
        id={this.flexComponent.id}
        data-fm={this.flexComponent.fmId}
        data-fm-title-id={this.flexComponent.fmTitleId}
      >
        <EditorialInfoView items={this.editorial.items} props={props} />
      </div>
    );
  }
}

export default InfoViewEditorial;
